export default function ListHelpers() {
  return {
    indexMove(arr: any, oldIndex: any, newIndex: any) {
      if (newIndex >= arr.length) {
        let k = newIndex - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
      return arr;
    },
    sort(list: any, sortProp: any, sortOrder: any) {
      if (sortProp && sortOrder) {
        const sepratorChar = ".";
        let orderItemName = "";
        let orderItem2Name = "";
        if (sortProp.includes(sepratorChar)) {
          orderItemName = sortProp.split(sepratorChar)[0];
          orderItem2Name = sortProp.split(sepratorChar)[1];
        } else {
          orderItemName = sortProp;
        }

        function compareFunction(a: any, b: any) {
          let aItem = a[orderItemName];
          let bItem = b[orderItemName];
          if (orderItem2Name) {
            aItem = a[orderItemName][orderItem2Name];
            bItem = b[orderItemName][orderItem2Name];
          }

          if (typeof aItem === "undefined" || aItem === null) {
            return -1;
          }

          if (typeof bItem === "undefined" || bItem === null) {
            return 1;
          }
          if (typeof aItem === "string") {
            if (aItem.toLowerCase() < bItem.toLowerCase()) {
              return -1;
            }
            if (aItem.toLowerCase() > bItem.toLowerCase()) {
              return 1;
            }
            return 0;
          } else if (typeof aItem === "number") {
            return aItem - bItem;
          }
        }

        if (sortOrder && sortOrder.toLowerCase() === "desc") {
          list = list.sort(compareFunction).reverse();
        } else {
          list = list.sort(compareFunction);
        }
      }
      return list;
    },
  };
}
